import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import ApproacheSection from "./components/ApproacheSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ServicesSection />
        <ApproacheSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
